import React from 'react';
import { withRouter } from '../../../../../common/withRouter';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { cloneObject } from '../../../common/utils';
import { Button, Link } from '../ActionElement';
import CollapsibleMobileMenuController from './_CollapsibleMobileMenuController';

const Menu = (
  {
    title,
    isTabList,
    isMenuExpanded,
    isCollapsibleOnMobile,
    className,
    items,
    location,
    orientation = 'horizontal'
  }
) => {
  const classNames = [`menu-${orientation}`];
  let menuId;

  if (className) {
    classNames.push(className);
  }

  const menuAttributes = {
    title,
    className: classNames.join(' ')
  };

  if (isTabList) {
    menuAttributes.role = 'tablist';
  }

  if (isCollapsibleOnMobile) {
    menuId = uuidv4();
    menuAttributes.id = menuId;
  }

  const menuElement = (
    <nav {...menuAttributes}>
      {items.map(({ linkProps, buttonProps, element }) => {
        switch (true) {
          case element !== undefined:
            return element;

          case buttonProps !== undefined: {
            const { buttonContent } = buttonProps;
            const finalButtonProps = cloneObject(buttonProps, {}, ['buttonContent']);
            return <Button {...finalButtonProps}>{buttonContent}</Button>;
          }

          case linkProps !== undefined: {
            const { path, label } = linkProps;

            const linkAttributes = cloneObject(
              linkProps, {
                to: path,
                key: path,
                iconAttributes: {
                  fixedWidth: true
                }
              }, ['path', 'label']);

            const regexCurrentPath = new RegExp(`(${path}/*.*)`);
            const isActiveLink = regexCurrentPath.test(location.pathname);

            if (isActiveLink) {
              linkAttributes.className = 'active';
            }

            if (isTabList) {
              linkAttributes.role = 'tab';
              linkAttributes['aria-selected'] = isActiveLink;
            }

            return <Link {...linkAttributes}>{label}</Link>;
          }

          default:
            console.error('Missing or invalid props in "Menu"');
            return false;
        }
      })}
    </nav>
  );

  return !isCollapsibleOnMobile ? menuElement : (
    <CollapsibleMobileMenuController isMenuExpanded={isMenuExpanded} menuId={menuId}>
      {menuElement}
    </CollapsibleMobileMenuController>
  );
};

Menu.propTypes = {
  title: PropTypes.string.isRequired,
  orientation: PropTypes.oneOf(['vertical', 'horizontal']),
  isCollapsibleOnMobile: PropTypes.bool,
  isMenuExpanded: PropTypes.bool,
  isTabList: PropTypes.bool,
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      linkProps: PropTypes.shape({
        path: PropTypes.string.isRequired,
        label: PropTypes.string,
        iconName: PropTypes.string
      }),
      buttonProps: PropTypes.object,
      element: PropTypes.element
    })
  ).isRequired
};

export default withRouter(Menu);